import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { listAuditLogsPromise, listRetryUserReportLogsPromise } from 'src/utils/api/list-audit-logs';
import { useSearch } from 'src/hooks/use-search';

export const useListAuditLogs = () => {
  const [searchParams] = useSearch();

  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useListAuditLogs, searchParams?.log_type, searchParams?.search],
    queryFn: () =>
      listAuditLogsPromise({
        log_type: searchParams?.log_type || [],
        search: searchParams?.search || '',
      }),
  });

  return {
    data,
    isLoading,
    error,
  };
};

/**@deprecated */
export const useListRetryReportLogs = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useListRetryReportLogs],
    queryFn: () => listRetryUserReportLogsPromise(),
  });

  return {
    data,
    isLoading,
    error,
  };
};
